function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.7,
  y: 0.7,
  width: 26.6,
  height: 26.6,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0758 16.1955L12.9912 14.1108L13.0158 14.0858C14.4438 12.4746 15.4615 10.6224 16.0606 8.66231H18.4653V6.99706H12.7204V5.33594H11.0789V6.99706H5.33398V8.64985H14.5013C13.9473 10.2528 13.0814 11.7727 11.8996 13.1016C11.1364 12.242 10.5044 11.3076 10.0038 10.3193H8.3624C8.9615 11.6731 9.78223 12.9521 10.8081 14.1066L6.63479 18.2801L7.79611 19.4554L11.8997 15.3026L14.4521 17.8856L15.0758 16.1955Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6964 11.9797H18.055L14.3618 21.9464H16.0032L16.9265 19.4547H20.8249L21.7482 21.9464H23.3896L19.6964 11.9797ZM17.5421 17.7936L18.8757 14.1932L20.2094 17.7936H17.5421Z",
  fill: "currentColor"
});

var SvgIcLanguage = function SvgIcLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_language.f5910a68.svg";
export { ForwardRef as ReactComponent };